module.exports = __webpack_public_path__ + "img/3-5.2fb69f4c.svg";